import angular from 'angular'

import template from './vd-promo.html'

angular.module('vend.ui').directive('vdPromo', function (vdImageCdnPathFilter) {
  return {
    restrict: 'E',
    scope: {
      headline: '=',
      image: '=',
      cdnImage: '=',
      modifier: '=',
      isDisabled: '=',
      imageRestrained: '=',
    },
    transclude: true,
    template,
    bindToController: true,
    controllerAs: 'vdPromoCtrl',
    controller($scope) {
      /**
       * Returns the source of the promo image.
       *
       * @method getPromoImage
       *
       * @return {String} The image src of the promo image.
       */
      this.getPromoImage = function () {
        let promoImage = this.image

        if (this.cdnImage) {
          promoImage = vdImageCdnPathFilter(this.cdnImage)
        }

        return promoImage
      }
    },
    link(scope, $element, attrs) {
      const VD_PROMO_CLASS = 'vd-promo'
      const promoClasses = [VD_PROMO_CLASS]

      if (attrs.modifier) {
        promoClasses.push(`${VD_PROMO_CLASS}--${attrs.modifier}`)
      }

      attrs.$addClass(promoClasses)
    },
  }
})
